import { render, staticRenderFns } from "./RegistrationDataInfo.vue?vue&type=template&id=2697a961&scoped=true&"
import script from "./RegistrationDataInfo.vue?vue&type=script&lang=js&"
export * from "./RegistrationDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDataInfo.vue?vue&type=style&index=0&id=2697a961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2697a961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2697a961')) {
      api.createRecord('2697a961', component.options)
    } else {
      api.reload('2697a961', component.options)
    }
    module.hot.accept("./RegistrationDataInfo.vue?vue&type=template&id=2697a961&scoped=true&", function () {
      api.rerender('2697a961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/RegistrationDataInfo.vue"
export default component.exports